/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { crosshairPropTypes } from '../props';
import CrosshairLine from './CrosshairLine';

var Crosshair = memo(function (_ref) {
    var width = _ref.width,
        height = _ref.height,
        type = _ref.type,
        x = _ref.x,
        y = _ref.y;

    var xLine = void 0;
    var yLine = void 0;
    if (type === 'cross') {
        xLine = { x0: x, x1: x, y0: 0, y1: height };
        yLine = { x0: 0, x1: width, y0: y, y1: y };
    } else if (type === 'top-left') {
        xLine = { x0: x, x1: x, y0: 0, y1: y };
        yLine = { x0: 0, x1: x, y0: y, y1: y };
    } else if (type === 'top') {
        xLine = { x0: x, x1: x, y0: 0, y1: y };
    } else if (type === 'top-right') {
        xLine = { x0: x, x1: x, y0: 0, y1: y };
        yLine = { x0: x, x1: width, y0: y, y1: y };
    } else if (type === 'right') {
        yLine = { x0: x, x1: width, y0: y, y1: y };
    } else if (type === 'bottom-right') {
        xLine = { x0: x, x1: x, y0: y, y1: height };
        yLine = { x0: x, x1: width, y0: y, y1: y };
    } else if (type === 'bottom') {
        xLine = { x0: x, x1: x, y0: y, y1: height };
    } else if (type === 'bottom-left') {
        xLine = { x0: x, x1: x, y0: y, y1: height };
        yLine = { x0: 0, x1: x, y0: y, y1: y };
    } else if (type === 'left') {
        yLine = { x0: 0, x1: x, y0: y, y1: y };
    } else if (type === 'x') {
        xLine = { x0: x, x1: x, y0: 0, y1: height };
    } else if (type === 'y') {
        yLine = { x0: 0, x1: width, y0: y, y1: y };
    }

    return React.createElement(
        React.Fragment,
        null,
        xLine && React.createElement(CrosshairLine, { x0: xLine.x0, x1: xLine.x1, y0: xLine.y0, y1: xLine.y1 }),
        yLine && React.createElement(CrosshairLine, { x0: yLine.x0, x1: yLine.x1, y0: yLine.y0, y1: yLine.y1 })
    );
});

Crosshair.displayName = 'Crosshair';
Crosshair.propTypes = process.env.NODE_ENV !== "production" ? {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    type: crosshairPropTypes.type.isRequired
} : {};
Crosshair.defaultProps = {
    type: 'cross'
};

export default Crosshair;